import { render, staticRenderFns } from "./OCButton.vue?vue&type=template&id=35cb794a&scoped=true&"
import script from "./OCButton.vue?vue&type=script&lang=ts&"
export * from "./OCButton.vue?vue&type=script&lang=ts&"
import style0 from "./OCButton.vue?vue&type=style&index=0&id=35cb794a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cb794a",
  null
  
)

export default component.exports